import { createContext } from "react";

export const GraphContext = createContext();
